import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewRef} from '@angular/core';
import {Filter} from '../../classes/filter';
import {FilterService} from '../../services/filter.service';
import {DynamicSearchService} from '../../../worklist/services/dynamic-search.service';
import {Subject, throwError} from 'rxjs/index';
import {catchError, distinctUntilChanged, finalize, map, switchMap, take, takeUntil} from 'rxjs/operators';
import {forkJoin} from 'rxjs/observable/forkJoin';
import {cloneDeep, get, isEmpty, isEqual, sortBy,set as lodashSet,remove} from 'lodash'
import {Observable} from 'rxjs';
import {
    BundleDynamicSearchPayload,
    DynamicSearchPayload,
    DynamicSearchType,
    Target
} from '@ispm-shared/modules/common/dynamic-search';
import {AdaptiveFilterService} from '@ispm/shared/services/adaptive-filter.service';
import { SimpleSearchService } from '../../../worklist/services/simple-search.service';
import {NotesService} from "@ispm/user/services/notes.service";

const WORKLIST_ROW = 'WorkListRow';
const UIPRACTWORKLIST_ROW = 'UIPractWorkListRow';
@Component({
    selector: 'gen-filter-bucket',
    templateUrl: './filter-bucket.component.html',
    styleUrls: ['./filter-bucket.component.scss']
})

export class FilterBucketComponent implements  OnInit, OnDestroy {

    @Input() type: string;
    @Input() subtype: string;
    @Input() dynamicSearch: DynamicSearchPayload;
    @Input() worklistQuickFiltersConfig: [];
    @Input() adaptableFilters: Array<any>;
    @Input() worklistTemplate: any;
    @Input() dynamicSearchWithAllItemsBucket: string;

    private asyncdestroyer: Subject<any> = new Subject();
    public filterItems = [];
    public filterItemsDisplay = [];
    public selectedFilterItem;
    @Input() _association: Array<any>;
    private bundleFilter: Array<Observable<any>> = [];
    private setTimeoutId: any;
    @Input() _resource: string;
    @Input() showZeroCountFilter: boolean = false;
    private _filterList:Map<string, Filter> = new Map<string, Filter>();
    private separateQueryFilters: { [key: string]: number} = {}; //Map queries key and id inside the bundle of queries that run separately (thier count is not returned in the general count query). In use for user filters and for predefined filters not on 'stauts' field

    @Input('filterList')

    set filterList(value: Map<string, Filter>) {
        if ((value.size > 0) && !isEqual(this._filterList, value)) {
            this._filterList = value;
            this.filterItems = this.getFilterItemsDisplay(this._filterList);
            this.filterItemsDisplay = [...sortBy(this.filterItems, o => o.priority)];
            let defaultFilter: Filter;
            this._filterList.forEach((item: Filter) => {
             if (item.default) {
               defaultFilter = item;
             }
            });
            if (defaultFilter && defaultFilter.query) {
                this.onChangeSelectedFilter(defaultFilter);
           }
        }
    }

    constructor(
        private filterService: FilterService,
        private changeDetector: ChangeDetectorRef,
        private dynamicsSearchService: DynamicSearchService,
        private adaptableFilterService: AdaptiveFilterService,
        private simpleSearchService: SimpleSearchService,
        private notesService: NotesService) {

    }

    ngOnInit() {
      this.filterService.getCurrentSelectedFilterFromStore(true).pipe(distinctUntilChanged(), takeUntil(this.asyncdestroyer.asObservable())).filter(data => ((data !== undefined) && !(isEmpty(data)))).subscribe((data) => {
        this.selectedFilterItem = data.filter;
      });

      this.filterService.getCurrentSelectedFilterQueryFromStore().pipe(distinctUntilChanged(), takeUntil(this.asyncdestroyer.asObservable())).filter(data => ((data !== undefined))).subscribe((data) => {
        if (isEmpty(data)) {
          return;
        }
        const keys = Object.keys(data);
        let query = '';
        if (Array.isArray(keys)) {
          keys.forEach((key, index) => {
            if (index != keys.length - 1) {
              query += key + '=' + data[key] + '&';
            } else {
              query += key + '=' + data[key];
            }
          });
         const currQuery =  get(this.selectedFilterItem, 'query');
          if (currQuery && (query != currQuery) && !(this.doesHavecustomQueryKeys(currQuery))) {
            this.selectedFilterItem = { };
          }
          this._filterList.forEach((filterItem) => {
            if (query == get(filterItem, 'query')) {
              this.selectedFilterItem = this.filterItemsDisplay.find(item => item.id === filterItem.id);
            }
          });
          }
      });

    }

    private getFilterItemsDisplay(filterList): Array<any> {
        const savedFilterItems  = [];
        const defaultFilters: Filter[] = [];
        const managedFilters: Filter[] = [];
        const filtersData: any[] = [];

        if (filterList) {
            filterList.forEach((currentFilterData: Filter) => {
                if (!currentFilterData.default) {
                    if (currentFilterData.id !== '0') {
                        managedFilters.push(currentFilterData);
                    }
                } else {
                    defaultFilters.push(currentFilterData);
                }
            });
        }

        const orderedManagedFilters: Filter[] = this.filterService.orderManagedFiltersAscByCreateData(managedFilters);

        if (defaultFilters.length > 0) {
            filtersData.push(...defaultFilters);
        }
        if (orderedManagedFilters.length > 0) {
            filtersData.push(...orderedManagedFilters);
        }
        this.bundleFilter.length = 0;

        for (let i = 0; i < filtersData.length; i++) {
            const filterItem = {
                name: filtersData[i].name,
                id: filtersData[i].id,
                undeletable: filtersData[i].hasOwnProperty('undeletable') ? filtersData[i].undeletable : false,
                count: '-1',
                disabled: filtersData[i].id === '0',
                priority: filtersData[i].priority,
                query: filtersData[i].query,
                showZeroCountFilter: this.alwaysShowFilter(filtersData[i])
            };
            savedFilterItems.push(filterItem);
            this.bundleFilter.push(this.getFilterPropertyTransformation(filtersData[i]));
        }
        this.setTimeoutId = setTimeout(()=>{
          if (this.simpleSearchService.isSimpleSearch(this.worklistTemplate)){
            this.setSimpleSearchFiltersCount();
          }
          else{
            this.execCountQuery();
          }
        }, 2000);
        return savedFilterItems;
    }

    private execCountQuery(){
      let bundleDySearch:Array<BundleDynamicSearchPayload> = [];
      this.dynamicSearch.target._count = 0;
      this.dynamicSearch.target._page  = 0;
      this.dynamicSearch.sort = []; //As we need only count with out the limit we don't need sort
      let filterIdx: number = 0;
      forkJoin(this.bundleFilter).pipe(
        takeUntil(this.asyncdestroyer.asObservable()),
        map((res) => {
          clearTimeout(this.setTimeoutId);
          let oneDySearch:BundleDynamicSearchPayload;
          res.forEach((storeFilter) => {
            if (storeFilter.currentSelectedFilter.filter.userFilter ||
                (storeFilter.currentSelectedFilter.filter.query != '' && //All filter
                !this.isStatusOnlyFilter(storeFilter.currentSelectedFilter.filter.query))) { //Sending queries only for user created filters. general quick filters count will be fetched in a single count query
              let transformedFilter = Object.assign({}, this.dynamicsSearchService.setDynamicSearchFilter(cloneDeep(this.dynamicSearch), this._association, storeFilter.appliedFilterProperties, true));

              if (!!this.adaptableFilters && this.adaptableFilters.length > 0) {
                let filterName = storeFilter.currentSelectedFilter.filter.id;
                // prepare data for current filter from adaptable list
                let currentAdaptableFilters: Array<any> = this.adaptableFilters.find(filter => filter.id === filterName);
                let filters:any[] = get(currentAdaptableFilters, 'filters', []);
                filters.forEach(adFilter => {
                  let newFilter = Object.assign(this.adaptableFilterService.getFilter(adFilter));
                  transformedFilter.filters.push(newFilter);
                });
                // collect new relations from adaptable list
                this.setData(currentAdaptableFilters, transformedFilter, 'relations');
                // collect new sort definitions from adaptable list
                this.setData(currentAdaptableFilters, transformedFilter, 'sort');

              }
              remove(transformedFilter.filters, singleFilter => singleFilter.excludeFromBundle === true);
              remove(transformedFilter.relations, singleRelation => singleRelation.excludeFromBundle === true);// Some relations are only for data count doesnt need them
              oneDySearch = new BundleDynamicSearchPayload(this._resource, DynamicSearchType.statistics, transformedFilter);
              lodashSet(oneDySearch,'searchBody.target._fieldslist',''); // Since quick filter just want numbers so no need of field list
              this.separateQueryFilters[storeFilter.currentSelectedFilter.filter.id] = filterIdx++; //Saves the query position in the bundle
              bundleDySearch.push(oneDySearch);
            }
          }
          )
          if (this._resource === UIPRACTWORKLIST_ROW || this._resource === WORKLIST_ROW || this.dynamicSearchWithAllItemsBucket){
            bundleDySearch.push(this.getCountQuery());
          }
        }),
          switchMap(data => this.dynamicsSearchService.getBundleDySearch(bundleDySearch)),
          catchError(err => {
              console.error('Dynamic Search Bundle : Error : ',err.message);
              return throwError(err);
          }),
          finalize(() => this.bundleFilter.length = 0)
          ).subscribe((dyBundleResponse: any) => {
            this.setQuickFiltersCount(dyBundleResponse);
            if(this.changeDetector && !((<ViewRef>this.changeDetector).destroyed)) {
              this.changeDetector.markForCheck();
              this.changeDetector.detectChanges();
            }
          });
    }

    private isStatusOnlyFilter(query: string): boolean{
      //Checks if the filter is on status ONLY field. If it is on other field or it is on status but on other field as well, return false.
      if (query.toUpperCase().startsWith('STATUS')) { //Verifing it is an equal search (not > or <) and that only one parameter,which is status, is in the query (no two '=')
        if (query.includes('=') && query.indexOf('=') === query.lastIndexOf(('='))){
          return true;
        }
      }
      return false;
    }

    private extractValueFromQueryParameter(query: string): string {
      //Query parameter format 'status=Review' (should return 'Review')
      let parameterValue: string = '';
      if (query){
        const pos: number = query.indexOf('=');
        if (pos > -1){
          parameterValue = query.substring(pos + 1).replace(/%20/gi, ' ');
        }
      }
      return parameterValue;
    }

    setQuickFiltersCount(dyBundleResponse: any){
      //Parse generalFilters which contains the counts of all general filters (user filters and predefined non-status filters are not inside)
      for (let filterItem of this.filterItems){
        //Getting status from the query parameter. This is the query parameter format: 'status=Therapy%20Ranking%201'
        let status: string = this.extractValueFromQueryParameter(filterItem.query);
        if (!!status && !!dyBundleResponse.generalFilters['_grpKey.statistics']){
          for (const countResult of dyBundleResponse.generalFilters['_grpKey.statistics']){
            const statusArr: string[] = status.split(','); //Handle the case when the query is on multiple values (e.g.: "status=Test Completed,Test completed")
           let found: boolean;
            for (const currStatus of statusArr){
              if (!!countResult[currStatus]){
                filterItem.count = countResult[currStatus];
                found = true;
                break;
              }
            }
            if (found){
              break;
            }
            else if (filterItem.count === '-1'){
              filterItem.count = '0';
            }
          }
        }
        else { //Empty status means query without filter which is the ALL items wuick filter
          if (dyBundleResponse.generalFilters && dyBundleResponse.generalFilters.hasOwnProperty(this._resource)){
            filterItem.count = dyBundleResponse.generalFilters[this._resource];
          }
        }
      }

      //Find the counts for filters that were send in a separate query in the bundle
      if (dyBundleResponse.additionalFilters.length > 0){
        Object.keys(this.separateQueryFilters).forEach(filterId => {
          let filterItem = this.filterItems.find(filterItem => filterItem.id === filterId); //Find the filter item
          if (filterItem){
            let responseItem = dyBundleResponse.additionalFilters[this.separateQueryFilters[filterId]]; //Find the response in the bundle respnse
            filterItem.count = responseItem.totalEntities;
          }
        })
      }
    }

  clearHighlighted() {
    this.filterService.getDefaultFilter(this.type, this.subtype).subscribe(defaultFilterRes => {
      this.selectedFilterItem = defaultFilterRes;
    })
  }

    getCountQuery(): BundleDynamicSearchPayload {
      let searchQueryTarget: Target = new Target(0, 0);
      let dynamicSearchPayload: DynamicSearchPayload = new DynamicSearchPayload(searchQueryTarget) ;
      dynamicSearchPayload.filters = [];
      searchQueryTarget._grpKey = this._resource === UIPRACTWORKLIST_ROW ? searchQueryTarget._grpKey = '{revStatus}' : '{DiagnosticOrder#WorkflowRequest,latestRevisionStatus}';
      dynamicSearchPayload.filters = cloneDeep(this.worklistTemplate.dynamicSearch.dataQuery.filters);
      const bundleItem: BundleDynamicSearchPayload = new BundleDynamicSearchPayload(this._resource, DynamicSearchType.statistics, dynamicSearchPayload);
      return bundleItem;
    }

    setSimpleSearchFiltersCount() {
      this.filterItems.forEach((filter, index) => {
        this.simpleSearchService.search(this.worklistTemplate.simpleSearch, null, null, null, null, null, filter,
          true, null, this.worklistTemplate.associationItems).pipe(take(1),
          map(results => {
            clearTimeout(this.setTimeoutId);
            if (Array.isArray(results) && results.length > 0 && !isNaN(results[0].count)) {
              this.filterItems[index].count = results[0].count;
              if (this.changeDetector && !((<ViewRef> this.changeDetector).destroyed)) {
                this.changeDetector.markForCheck();
                this.changeDetector.detectChanges();
              }
            }
          })
        ).subscribe();
      });
    }
    private alwaysShowFilter(filtersData: Filter): boolean {
      if (this.showZeroCountFilter) {
        return true;
      }
      let showFilter: boolean = false;

      // Filter will be shown if in the worklistTemplate the filter id is configured as showZeroCountFilter=true
      if (this.worklistQuickFiltersConfig && Array.isArray(this.worklistQuickFiltersConfig)) {
        const filterConfig = this.worklistQuickFiltersConfig.find(item => item['id'] === filtersData.id);
        showFilter = filterConfig && filterConfig['showZeroCountFilter'];
      }
      if (!showFilter) {
        showFilter = !filtersData.query && !filtersData.queryString; // Empty query means All filters that should always be visible
        if (!showFilter) {
          // User filters should always be visible.
          // If UserId reference is not null it mean it is a user filter. For example
          // context{:}
          // {reference: "56af88ac-af05-11e6-93d5-000c29952efb", resourceType: "UserId"}
          const userReference = filtersData.context.find(item => item.resourceType == 'UserId');
          showFilter = userReference != null && userReference.reference.toUpperCase() != 'NULL';
        }
      }
      return showFilter;
    }

    private getAllFiltersCount(filter, i) {
        const selectedFilterValues = this.filterService.buildFiltersValuesMap(filter);
        const key = this.type + '_' + this.subtype;
        this.filterService.updateSavedFilterPropsValues(key, filter, selectedFilterValues).pipe(take(1), distinctUntilChanged(), takeUntil(this.asyncdestroyer.asObservable()))
            .subscribe((filterProperties: any) => {
               if ((key === get(filterProperties, 'currentSelectedFilter.filterTypeAndSubtype'))) {
                 this.dynamicsSearchService.getAllCounts(filterProperties.appliedFilterProperties, this.dynamicSearch, true)
                   .pipe(take(1),
                     catchError(err => {
                       console.error('Filter count : Error : ',err.message);
                       this.filterItems[i].count = -1;
                       return throwError(err);
                     }))
                   .subscribe(
                     (data: any) => {
                       if (this.filterItems[i]) {
                         this.filterItems[i].count = data.totalEntities;
                         this.filterItemsDisplay = [...sortBy(this.filterItems, o => o.priority)];
                         this.changeDetector.markForCheck();
                       }
                     });
                 }
            });

    }

  private getFilterPropertyTransformation(filter): Observable<any> {
    const selectedFilterValues = this.filterService.buildFiltersValuesMap(filter);
    const key = this.type + '_' + this.subtype;
    return this.filterService.updateSavedFilterPropsValues(key, filter, selectedFilterValues).pipe(take(1), distinctUntilChanged(), takeUntil(this.asyncdestroyer.asObservable()))
      .filter((filterFromStore) => {
        return (key === get(filterFromStore, 'currentSelectedFilter.filterTypeAndSubtype'));
      }).map(data => cloneDeep(data));
  }

  private bundleCallFilters() {
    const bundleDySearch: Array<BundleDynamicSearchPayload> = [];
    this.dynamicSearch.target._count = 0;
    this.dynamicSearch.target._page  = 0;
    this.dynamicSearch.sort = []; // As we need only count with out the limit we don't need sort
    forkJoin(this.bundleFilter).pipe(takeUntil(this.asyncdestroyer.asObservable()),
      map((res) => {
        let oneDySearch: BundleDynamicSearchPayload;
        res.forEach((storeFilter) => {

          const transformedFilter = Object.assign({ }, this.dynamicsSearchService.setDynamicSearchFilter(cloneDeep(this.dynamicSearch), this._association, storeFilter.appliedFilterProperties, true));

          if (!!this.adaptableFilters && this.adaptableFilters.length > 0) {
            const filterName = storeFilter.currentSelectedFilter.filter.id;
            // prepare data for current filter from adaptable list
            const currentAdaptableFilters: Array<any> = this.adaptableFilters.find(filter => filter.id === filterName);
            const filters: any[] = get(currentAdaptableFilters, 'filters', []);
            filters.forEach(adFilter => {
              const newFilter = Object.assign(this.adaptableFilterService.getFilter(adFilter));
              transformedFilter.filters.push(newFilter);
            });
            // collect new relations from adaptable list
            this.setData(currentAdaptableFilters, transformedFilter, 'relations');
            // collect new sort definitions from adaptable list
            this.setData(currentAdaptableFilters, transformedFilter, 'sort');

          }
          remove(transformedFilter.filters, singleFilter => singleFilter.excludeFromBundle === true);
          remove(transformedFilter.relations, singleRelation => singleRelation.excludeFromBundle === true); // Some relations are only for data count doesnt need them
          oneDySearch = new BundleDynamicSearchPayload(this._resource, DynamicSearchType.statistics, transformedFilter);
          lodashSet(oneDySearch, 'searchBody.target._fieldslist', ''); // Since quick filter just want numbers so no need of field list
          bundleDySearch.push(oneDySearch);
        });
      }),
        switchMap(() => this.dynamicsSearchService.getBundleDySearch(bundleDySearch)),
        catchError(err => {
            console.error('Dynamic Search Bundle : Error : ', err.status,'-',err.message);
            return throwError(err);
        }),
        finalize(() => this.bundleFilter.length = 0)
        ).subscribe((dyBundleResponse: any) => {
        dyBundleResponse.forEach((response, index) => {
          this.filterItems[index].count = response.totalEntities;
        });
        if (this.changeDetector && !((<ViewRef> this.changeDetector).destroyed)) {
          this.changeDetector.markForCheck();
          this.changeDetector.detectChanges();
        }
      });
  }

    public onChangeSelectedFilter(item: any) {
      this.selectedFilterItem = item;
      this.filterService.changeSelectedFilter(item.id, this.type, this.subtype, this.changeDetector);
      this.notesService.revisionIdsReset();// This will clear the array of revision ids retained in the service
    }

  public reCalculateFilters() {
    this.filterItems = this.getFilterItemsDisplay(this._filterList);
    this.filterItemsDisplay = [...sortBy(this.filterItems, o => o.priority)];
  }

  public trackByfilterId(index: number, item: Filter): string {
      return item.id;
  }

  private doesHavecustomQueryKeys(query: string): boolean {
      query = query.toString();
      const customQueryStrings = ['nextweek', 'comingweek', 'now'];
      return customQueryStrings.some((el) => query.toLowerCase().includes(el.toLowerCase()));
  }

  ngOnDestroy(): void {
    this.asyncdestroyer.next();
    this.asyncdestroyer.complete();
  }

  private setData(currentAdaptableFilters, filter: any, property: string) {
    const descriptors: any[] = get(currentAdaptableFilters, property, []);
    descriptors.forEach(adRelation => {
      filter[property].push(Object.assign(adRelation));
    });
  }
}
